import { render, staticRenderFns } from "./ManageDiscussion.vue?vue&type=template&id=06639400&"
import script from "./ManageDiscussion.vue?vue&type=script&lang=js&"
export * from "./ManageDiscussion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports